module.exports = __webpack_public_path__ + "static/logo-af161a3c1cd7b414cb2f378696104a9c.png";